import React, { Fragment } from "react";
import { Col, FormGroup, Label, Row } from "reactstrap";

const CloseReasonsSettingForm = (props) => {
  const { errors, register } = props;

  return (
    <Fragment>
      <Row>
        <Col>
          <FormGroup>
            <Label className="col-form-label">Close Reason Name</Label>
            <input
              type="text"
              {...register("reason")}
              className={`form-control ${errors.reason ? "is-invalid" : ""}`}
            />
            <div className="invalid-feedback">{errors.reason?.message}</div>
          </FormGroup>
        </Col>
      </Row>
    </Fragment>
  );
};

export default CloseReasonsSettingForm;
